import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Toast } from 'antd-mobile';
import { withRouter } from 'react-router-dom';
import { InfiniteScroll } from 'antd-mobile-v5';
import no_content_risk from '../../static/images_ae/no_content_risk.png';
import styles from './record.module.scss';

const api = new ApiCore();

const Chest = (props: any) => {

    const [data, setData] = useState<string[]>([]);
    const [hasMore, setHasMore] = useState(true);
    const [curPage, setCurPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState<any>(null);
    const [listReady, setListReady] = useState<any>(false);

    useEffect(() => {
        window.document.title = 'ALK风险评估记录';
    }, [])

    const getData = () => {
        return new Promise<any>((resolve, reject) => {
            if (total !== null && curPage * pageSize >= total) {
                setHasMore(false);
                resolve([]);
            }
            let _curPage = curPage;
            _curPage++;
            setCurPage(_curPage)
            api.getEvaluationPage({
                page: _curPage,
                pageSize: pageSize
            }).then((res: any) => {
                if (res.code == 0) {
                    setTotal(res.data?.total)
                    if (_curPage * pageSize >= res.data?.total) {
                        setHasMore(false);
                    }
                    resolve(res.data?.rows);
                }
            })
        })
    }

    async function loadMore() {
        const append = await getData();
        setData(val => [...val, ...append]); // setHasMore(append.length > 0)
        setListReady(true);
      }

    const toDetail = (val: any) => {
        props.history.push('/ae/reporting/detail?reportCode=' + val.reportCode);
    }

    
    return (
        <div className={styles.ae_reporting}>
            {
                data.map((val: any, key: number) => (
                    <div key={key} className={styles.item} onClick={() => { toDetail(val) }}>
                        <div className={styles.record}>ALK风险评估记录</div>
                        <div className={styles.sympton}>选择症状: <span>{val.symptoms}</span></div>
                        <div className={styles.risk}>疑似风险等级: <span>{val.risklevel || '暂无等级'}</span></div>
                        <div className={styles.way}>治疗方案: <span>{val.treatments}</span></div>
                        <div className={styles.time}>{val.createTime ? val.createTime.replace('T', ' ') : ''}</div>
                    </div>
                ))
            }
            {
                listReady && total == 0 &&
                <div className={styles.no_content}>
                    <img src={no_content_risk} alt="" />
                </div>
            }
            <InfiniteScroll loadMore={loadMore} hasMore={hasMore} >{''}</InfiniteScroll>
        </div>
    )
}

export default withRouter(Chest);